export default "__VITE_ASSET__BYswAl_b__"